<template>
  <div class="h3">Услуги и развлечения</div>

  <div v-if="!isQuestionnaireSent" class="paragraph-s_h text-secondary mt-4">
    <span class="text-red">*</span> — поля обязательные для заполнения
  </div>

  <e-form v-if="!isQuestionnaireSent" ref="formRef" class="mt-10">
    <inputs-group title="Бытовые службы">
      <combobox-with-list v-model="form.household" label="Добавить" :options="dictionaries?.servicesAndEntertainment.household || []" />
    </inputs-group>

    <inputs-group title="На стойке регистрации" class="mt-10">
      <combobox-with-list v-model="form.reception" label="Добавить" :options="dictionaries?.servicesAndEntertainment.reception || []" />
    </inputs-group>

    <inputs-group title="Аренда" class="mt-10">
      <combobox-with-list v-model="form.rent" label="Добавить" :options="dictionaries?.servicesAndEntertainment.rental || []" />
    </inputs-group>

    <inputs-group title="Доступ в интернет" class="mt-10">
      <combobox-with-list v-model="form.internet" label="Добавить" :options="dictionaries?.servicesAndEntertainment.internet || []" />
    </inputs-group>

    <inputs-group title="Прочие услуги" class="mt-10">
      <combobox-with-list v-model="form.other" label="Добавить" :options="dictionaries?.servicesAndEntertainment.other || []" />
    </inputs-group>

    <inputs-group title="Водные виды спорта" class="mt-10">
      <combobox-with-list v-model="form.waterSports" label="Добавить" :options="dictionaries?.servicesAndEntertainment.waterSports || []" />
    </inputs-group>

    <inputs-group title="Прокат спортивного инвентаря" class="mt-10">
      <combobox-with-list v-model="form.equipmentRental" label="Добавить" :options="dictionaries?.servicesAndEntertainment.equipmentRental || []" />
    </inputs-group>

    <inputs-group title="Услуги для горнолыжного отдыха" class="mt-10">
      <combobox-with-list v-model="form.skiResortServices" label="Добавить" :options="dictionaries?.servicesAndEntertainment.skiResortServices || []" />
    </inputs-group>

    <inputs-group title="Анимация" class="mt-10">
      <combobox-with-list v-model="form.animations" label="Добавить" :options="dictionaries?.servicesAndEntertainment.animations || []" />
    </inputs-group>
    
    <inputs-group title="Развлечения" class="mt-10">
      <combobox-with-list v-model="form.entertainmentTypes" label="Добавить" :options="dictionaries?.servicesAndEntertainment.sportAndEntertainmentTypes || []" />
    </inputs-group>

    <inputs-group title="Организация досуга" class="mt-10">
      <combobox-with-list v-model="form.leisure" label="Добавить" :options="dictionaries?.servicesAndEntertainment.leisure || []" />
    </inputs-group>

    <inputs-group title="Развлечения для детей" class="mt-10">
      <combobox-with-list v-model="form.childrenEntertainments" label="Добавить" :options="dictionaries?.servicesAndEntertainment.childrenEntertainments || []" />
    </inputs-group>

    <inputs-group title="Услуги для детей" class="mt-10">
      <combobox-with-list v-model="form.childrenServices" label="Добавить" :options="dictionaries?.servicesAndEntertainment.childrenServices || []" />
    </inputs-group>

    <inputs-group title="Прокат инвентаря для детей" class="mt-10">
      <combobox-with-list v-model="form.childrenEquipmentRental" label="Добавить" :options="dictionaries?.servicesAndEntertainment.childrenEquipmentRental || []" />
    </inputs-group>

    <inputs-group title="СПА-услуги" class="mt-10">
      <combobox-with-list v-model="form.spaServices" label="Добавить" :options="dictionaries?.servicesAndEntertainment.spaServices || []" />
    </inputs-group>

    <inputs-group title="Врачебная косметология" class="mt-10">
      <combobox-with-list v-model="form.medicalCosmetology" label="Добавить" :options="dictionaries?.servicesAndEntertainment.medicalCosmetology || []" />
    </inputs-group>

    <div class="d-flex justify-space-between mt-10">
      <e-btn variant="secondary" prepend-icon-src="arrowLeft" @click="back">Назад</e-btn>
      <e-btn variant="primary" append-icon-src="arrowRight" :loading="isLoading" @click="onSubmit(true)">Далее</e-btn>
    </div>
  </e-form>

  <div v-else class="mt-10">
    <template v-if="form.household.length">
      <div class="paragraph-m_h font-600 mb-2">Бытовые службы</div>
      <e-chip v-for="household in form.household" :key="household" class="mt-2 mr-2">
        {{ household }}
      </e-chip>
    </template>

    <template v-if="form.reception.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">На стойке регистрации</div>
      <e-chip v-for="reception in form.reception" :key="reception" class="mt-2 mr-2">
        {{ reception }}
      </e-chip>
    </template>

    <template v-if="form.rent.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Аренда</div>
      <e-chip v-for="rent in form.rent" :key="rent" class="mt-2 mr-2">
        {{ rent }}
      </e-chip>
    </template>

    <template v-if="form.internet.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Доступ в интернет</div>
      <e-chip v-for="internet in form.internet" :key="internet" class="mt-2 mr-2">
        {{ internet }}
      </e-chip>
    </template>

    <template v-if="form.other.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Прочие услуги</div>
      <e-chip v-for="other in form.other" :key="other" class="mt-2 mr-2">
        {{ other }}
      </e-chip>
    </template>

    <template v-if="form.waterSports.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Водные виды спорта</div>
      <e-chip v-for="waterSports in form.waterSports" :key="waterSports" class="mt-2 mr-2">
        {{ waterSports }}
      </e-chip>
    </template>

    <template v-if="form.equipmentRental.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Прокат спортивного инвентаря</div>
      <e-chip v-for="equipmentRental in form.equipmentRental" :key="equipmentRental" class="mt-2 mr-2">
        {{ equipmentRental }}
      </e-chip>
    </template>

    <template v-if="form.skiResortServices.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Услуги для горнолыжного отдыха</div>
      <e-chip v-for="skiResortServices in form.skiResortServices" :key="skiResortServices" class="mt-2 mr-2">
        {{ skiResortServices }}
      </e-chip>
    </template>

    <template v-if="form.animations.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Анимация</div>
      <e-chip v-for="animations in form.animations" :key="animations" class="mt-2 mr-2">
        {{ animations }}
      </e-chip>
    </template>
    
    <template v-if="form.entertainmentTypes.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Развлечения</div>
      <e-chip v-for="entertainmentTypes in form.entertainmentTypes" :key="entertainmentTypes" class="mt-2 mr-2">
        {{ entertainmentTypes }}
      </e-chip>
    </template>

    <template v-if="form.leisure.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Организация досуга</div>
      <e-chip v-for="leisure in form.leisure" :key="leisure" class="mt-2 mr-2">
        {{ leisure }}
      </e-chip>
    </template>

    <template v-if="form.childrenEntertainments.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Развлечения для детей</div>
      <e-chip v-for="childrenEntertainments in form.childrenEntertainments" :key="childrenEntertainments" class="mt-2 mr-2">
        {{ childrenEntertainments }}
      </e-chip>
    </template>

    <template v-if="form.childrenServices.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Услуги для детей</div>
      <e-chip v-for="childrenServices in form.childrenServices" :key="childrenServices" class="mt-2 mr-2">
        {{ childrenServices }}
      </e-chip>
    </template>

    <template v-if="form.childrenEquipmentRental.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Прокат инвентаря для детей</div>
      <e-chip v-for="childrenEquipmentRental in form.childrenEquipmentRental" :key="childrenEquipmentRental" class="mt-2 mr-2">
        {{ childrenEquipmentRental }}
      </e-chip>
    </template>

    <template v-if="form.spaServices.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">СПА-услуги</div>
      <e-chip v-for="spaServices in form.spaServices" :key="spaServices" class="mt-2 mr-2">
        {{ spaServices }}
      </e-chip>
    </template>

    <template v-if="form.medicalCosmetology.length">
      <div class="paragraph-m_h font-600 mt-10 mb-2">Врачебная косметология</div>
      <e-chip v-for="medicalCosmetology in form.medicalCosmetology" :key="medicalCosmetology" class="mt-2 mr-2">
        {{ medicalCosmetology }}
      </e-chip>
    </template>

    <div class="d-flex justify-space-between mt-10">
      <e-btn variant="secondary" prepend-icon-src="arrowLeft" @click="back">Назад</e-btn>
      <e-btn variant="primary" append-icon-src="arrowRight" :loading="isLoading" @click="nextStep">Далее</e-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';
import type { EFormType } from '@/core/types/components/components';
import ComboboxWithList from '@/core/components/interface/ComboboxWithList.vue';
import InputsGroup from '@/core/components/interface/InputsGroup.vue';
import { EBtn, EChip, EForm } from '@/core/components/ui';
import { compareObjects } from '@/core/utils/objects/get-delta';
import { QuestionnaireMasterStep } from '@/graphql/generated';
import { useContentStore } from '@/parts/content/store';

const {
  dictionaries,
  back,
  saveQuestionnaire,
  saveQuestionnaireDebounced,
  questionnaireAnswers,
  moveToNextStep,
  isQuestionnaireSent,
  nextStep,
  needValidate,
  completeValidation,
} = useContentStore();

const formRef = ref<EFormType>();

const form = reactive({
  household: questionnaireAnswers.value?.servicesAndEntertainment?.household ?? [],
  reception: questionnaireAnswers.value?.servicesAndEntertainment?.reception ?? [],
  rent: questionnaireAnswers.value?.servicesAndEntertainment?.rent ?? [],
  internet: questionnaireAnswers.value?.servicesAndEntertainment?.internet ?? [],
  other: questionnaireAnswers.value?.servicesAndEntertainment?.other ?? [],
  waterSports: questionnaireAnswers.value?.servicesAndEntertainment?.waterSports ?? [],
  equipmentRental: questionnaireAnswers.value?.servicesAndEntertainment?.equipmentRental ?? [],
  skiResortServices: questionnaireAnswers.value?.servicesAndEntertainment?.skiResortService ?? [],
  animations: questionnaireAnswers.value?.servicesAndEntertainment?.animation ?? [],
  entertainmentTypes: questionnaireAnswers.value?.servicesAndEntertainment?.entertainmentTypes ?? [],
  leisure: questionnaireAnswers.value?.servicesAndEntertainment?.leisure ?? [],
  childrenEntertainments: questionnaireAnswers.value?.servicesAndEntertainment?.childrenEntertainment ?? [],
  childrenServices: questionnaireAnswers.value?.servicesAndEntertainment?.childrenService ?? [],
  childrenEquipmentRental: questionnaireAnswers.value?.servicesAndEntertainment?.childrenEquipment ?? [],
  spaServices: questionnaireAnswers.value?.servicesAndEntertainment?.spaServices ?? [],
  medicalCosmetology: questionnaireAnswers.value?.servicesAndEntertainment?.medicalCosmetology ?? [],
});

const save = () => saveQuestionnaireDebounced(mapFormToQuestionnaire());
const saveIfHasChanges = async () => {
  if (hasChanges()) {
    await saveQuestionnaire(mapFormToQuestionnaire());
  }
};

watch(form, () => {
  void save();
});

const isLoading = ref(false);

const validate = async () => await formRef.value?.validate();

const hasChanges = () => {
  if (questionnaireAnswers.value?.servicesAndEntertainment) {
    delete questionnaireAnswers.value.servicesAndEntertainment.__typename;

    if (!compareObjects(mapFormToQuestionnaire().servicesAndEntertainment, questionnaireAnswers.value.servicesAndEntertainment)) {
      return true;
    }
  }

  return false;
};

const onSubmit = async (force = false) => {
  if (!force && !hasChanges()) {
    return true;
  }

  const isValid = await validate();
  if (!isValid) {
    return false;
  }

  isLoading.value = true;
  await moveToNextStep(QuestionnaireMasterStep.ServicesAndEntertainment, mapFormToQuestionnaire());
  isLoading.value = false;
  
  return true;
};

onMounted(async () => {
  if (needValidate.value) {
    await validate();
    await completeValidation();
  }
});

onBeforeUnmount(async () => {
  await saveIfHasChanges();
});

function mapFormToQuestionnaire() {
  return {
    servicesAndEntertainment: {     
      household: form.household,
      reception: form.reception,
      rent: form.rent,
      internet: form.internet,
      other: form.other,
      waterSports: form.waterSports,
      equipmentRental: form.equipmentRental,
      skiResortService: form.skiResortServices,
      animation: form.animations,
      entertainmentTypes: form.entertainmentTypes,
      leisure: form.leisure,
      childrenEntertainment: form.childrenEntertainments,
      childrenService: form.childrenServices,
      childrenEquipment: form.childrenEquipmentRental,
      spaServices: form.spaServices,
      medicalCosmetology: form.medicalCosmetology,
    },
  };
}

</script>
